import React from "react";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../../../components/molecules/Buttons/Buttons.component";
import { TextProps } from "./Text.interface";
import S from "./Text.module.scss";

const Text = (props: TextProps) => {
    return (
        <div className={S.wrapper}>
            {/** Headline */}
            {props.headline ? (
                <DA_Title h3 tag={DA_TitleTag.H3} noMargin fullWidth>
                    {props.headline}
                </DA_Title>
            ) : null}

            {/** Text */}
            {props.text ? <DA_Text html={props.text} noPadding /> : null}

            {/** Buttons */}
            <SSH_Buttons buttons={props.buttons} theme={props.buttonTheme} />
        </div>
    );
};

export default Text;
